import ContactIcon from '@/components/icons/ContactIcon'
import ShareIcon from '@/components/icons/ShareIcon'
import { useI18n } from '@runtime/core/i18n/i18n'
import styles from './HomeFooter.module.scss'
export default function HomeActions({ onShare }: { onShare: () => void }) {
  const { t } = useI18n()
  return (
    <div className={styles.actions}>
      <a href="mailto:contact@united-square.com">
        <ContactIcon />
        {t('home.contactTitle')}
      </a>
      <button type="button" onClick={onShare}>
        <ShareIcon />
        {t('common.share')}
      </button>
    </div>
  )
}
